import React from "react";
import classnames from "classnames";

const mapEmbeded = `<div style="width: 100%; filter: grayscale(50%) contrast(100%) brightness(100%)">
  <iframe width="100%" height="200" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"
    src="https://maps.google.com/maps?width=649&amp;height=200&amp;hl=en&amp;q=Villa+Sintica&amp;t=p&amp;z=13&amp;ie=UTF8&amp;iwloc=B&amp;output=embed">
  </iframe>
</div>`;

export default function Transport({isInner, t}) {
  return (
    <div className="transport bg-base" id="transport">
      <div>
        <div className="flex flex-justify-center">
          <div className={classnames("col-12", {
            "col-4-xl p-block-8 p-top-8-mxl p-bottom-8-mxl": !isInner,
          })}>
          <p className="text-xs text-center m-bottom-1 letter-spacing-2px"> <i className="fa-solid fa-map-pin m-right-0 text-sm" /> {t.locationLabel}</p>
            <div className="display-block m-auto">
              <div
                className="map-location"
                dangerouslySetInnerHTML={{ __html: mapEmbeded }}
              />
            </div>
            <p className="text-xs text-center m-top-1">{t.mapNote}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
